// removed by extract-text-webpack-plugin
module.exports = {"block":"-tl7gromDDIQMqWTt21Tv","content":"_1J-16JXM4U5SvdmEy_EQXU","icon-container":"_3Uqyq0r03YGAP8iabq43i4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieBlock/CookieBlock.module.scss
// module id = 744
// module chunks = 0